import React from 'react';
import { Button } from 'antd';
import styles from './index.less';

const Index = ({ onClick }) => (
  <div className={styles['pwd-setting']}>
    <div className={styles['pwd-setting_label']}>密码设置：</div>
    <div className={styles['pwd-setting_col']}>
      <Button onClick={onClick}>修改密码</Button>
      <div className={styles['pwd-setting_tips']}>说明: 设置数字字母结合8位字符</div>
    </div>
  </div>
);

export default Index;

